import { Ticket } from '../state/models/ticket.model';
import { DeliveryParameters } from './ticket-deliveryparams.model';
import { TicketActionType, TicketFlag, TicketMediaType } from './ticket.enums';

// tslint:disable: variable-name
export interface TicketViewModel {
  Row: string;
  GameNumber: number;
  Seat: string;
  ACN: number;
  Barcode: string;
  ProductCode: string;
  MemberId: string;
  Area: string;
  Stand: string;
  Flag: TicketFlag;
  IsInBasket: boolean;
  IsTransferToEmailAllowed: boolean;
  IsDonationAllowed: boolean;
  IsCallbackAllowed: boolean;
  WindowStartDate: Date | string;
  WindowEndDate: Date | string;
  TransfereeMemberId: string;
  TransfereePortalId: string;
  TransfereeExternalRefNumber: string;
  TransfereeEmailAddress: string;
  TransfereeFullName: string;
  RecipientEmailAddress: string;
  selected: boolean;
  TicketAction: TicketActionType;
  DeliveryParameters: DeliveryParameters;
  ShouldUseUniqueDeliveryParameters: boolean;
}

export interface TicketActionStatusModel extends TicketViewModel {
  IsTransferToEmailAllowed: boolean;
  IsTransferToMemberAllowed: boolean;
  IsDonationAllowed: boolean;
  IsResaleAllowed: boolean;
  IsUpgradeAllowed: boolean;
  IsCallbackAllowed: boolean;
  ShouldUsePendingTransfer: boolean;
  IsHidden: boolean;
  StartTime: Date | string;
  EndTime: Date | string;
  RequestTime: Date | string;
}

export class SubmitTicketRequestModel {
  Tickets: Ticket[];
  DeliveryParameters: { [key: string]: DeliveryParameters };
  UsePurchaseService: boolean;
}




export interface TicketTransactionModel {
  TransactionId: number;
  OrderId: string;
  OrderGroupId: string;
  PortalId: string;
  MemberId: string;
  ExternalRefNumber: string;
  ACN: number;
  FullName: string;
  EmailAddress: string;
  EventTypeId: number;
  TransactionLinkId: number;
  MediaType: TicketMediaType;
  TransactionTypeId: TicketTransactionType;
  ProductCode: string;
  Area: string;
  Stand: string;
  Row: string;
  Seat: string;
  PriceBand: string;
  GameNumber: number;
  GameName: string;
  Date: Date | string;
  LastUpdated: Date | string;
  TransfereePortalId: string;
  TransfereeMemberId: string;
  TransfereeExternalRefNumber: string;
  TransfereeACN: number;
  TransfereeFullName: string;
  TransfereeEmailAddress: string;
  TransfereeTransactionTypeId: TicketTransactionType;
  ATTENDANCE: Date | string;
}

export enum TicketTransactionType {
  TicketPrint = 1,
  RePrint = 2,
  SellBarcodeTicket = 3,
  CancelBarcodeTicket = 4,
  ActiveCardTicket = 5,
  CritcalCardCancel = 6,
  CritcalBarcodeCancel = 7,
  BarcodeTransferIn = 8,
  BarcodeTransferOut = 9,
  CardTransferIn = 10,
  CardTransferOut = 11,
  BarcodeLoadedToCard = 12,
  Transferred = 13,
  CallBack = 14,
  CallBackByOrignalMember = 15,
  ResaleActiveCardTicket = 16,
  ResaleCancelCardTicket = 17,
  ResaleSellBarcodeTicket = 18,
  ResaleCancelBarcodeTicket = 19,
  DonationCancelCardTicket = 20,
  DonationCancelBarcodeTicket = 21,
  DonationSellBarcodeTicket = 22,
}
